import * as React from 'react';
import { init } from './services/bootstrap/init-app';
import SiteApp from './components/SiteApp/SiteApp';

init(SiteApp);
